<template>
  <div class="page_tePayment">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" :loading="loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>暂支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/tePaymentList' }">待打款</el-breadcrumb-item>
          <el-breadcrumb-item>打款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="descriptions_box" id="printBox">
          <div class="descriptionsTitle" style="width:798px">{{baseInfo.applyCompany}}</div>
          <div class="descriptionsTitle" style="color: #666;width:798px">{{OAinfo.type}}</div>
          <el-descriptions :column="4" border :contentStyle="CS" :label-style="LS " style="width:800px;">

            <el-descriptions-item label="暂支编号" :span="2" :contentStyle="{'max-width': '200px','min-width': '200px','text-align': 'center'}">{{baseInfo.advanceNum}}</el-descriptions-item>
            <el-descriptions-item label="OA编号" :span="2">{{baseInfo.oanum}}</el-descriptions-item>

            <el-descriptions-item label="签单部门" :span="2" :contentStyle="{'max-width': '200px','min-width': '200px','text-align': 'center'}">{{baseInfo.applyDep}}</el-descriptions-item>
            <el-descriptions-item label="业务员" :span="2"></el-descriptions-item>

            <el-descriptions-item label="服务部门" :span="2">{{baseInfo.sevrvceDeptName}}</el-descriptions-item>
            <el-descriptions-item label="客服" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}"></el-descriptions-item>
            <el-descriptions-item label="申请日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.applyTime ? baseInfo.applyTime.split('T')[0] : ''}}</el-descriptions-item>

            <el-descriptions-item label="所属项目" :span="2">{{baseInfo.projectName}}</el-descriptions-item>
            <el-descriptions-item label="客户名称" :span="2">{{baseInfo.CustomerName }}</el-descriptions-item>

            <el-descriptions-item label="内容" :span="2">{{ baseInfo.costName }}</el-descriptions-item>
            <el-descriptions-item label="业务属性" :span="2"></el-descriptions-item>

            <el-descriptions-item label="金额 大写(RMB)" :span="2">{{ numberToChinese(baseInfo.totalFees) }}</el-descriptions-item>
            <el-descriptions-item label="￥：" :span="2">{{baseInfo.totalFees}}</el-descriptions-item>

            <el-descriptions-item label="备注" :span="4">{{baseInfo.descFees}}</el-descriptions-item>

            <el-descriptions-item label="申请人" :span="2">{{baseInfo.applyUserName}}</el-descriptions-item>
            <el-descriptions-item label="业务审核" :span="2"></el-descriptions-item>

            <el-descriptions-item label="出纳确认" :span="2"></el-descriptions-item>
            <el-descriptions-item label="出纳" :span="2"></el-descriptions-item>

          </el-descriptions>
        </div>

        <div>
          <el-form :model="payForm" :rules="rules" ref="payForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="打款金额" prop="TotalFees">
              <div class="payInput">
                <el-input v-model="payForm.TotalFees" size="small" style="width:300px" type="number">
                  <i slot="prepend">￥</i>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="打款公司" prop="name">
              <el-input v-model="baseInfo.remitAgency" size="small" style="width:300px" disabled readonly></el-input>
            </el-form-item>
            <el-form-item label="收款账号名称" prop="name">
              <el-input v-model="baseInfo.receiptAccountName" size="small" style="width:300px" readonly disabled></el-input>
            </el-form-item>
            <el-form-item label="银行开户行" prop="name">
              <el-input v-model="payForm.depositBank" size="small" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号" prop="name">
              <el-input v-model="baseInfo.receiptAccount" size="small" style="width:300px" readonly disabled></el-input>
            </el-form-item>
            <el-form-item label="款项用途" prop="UseFunds">
              <el-input v-model="payForm.UseFunds" size="small" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="联行号">
              <div ref="chickBox1">
                <el-input v-model="payForm.CnapsCode" placeholder="支持开户行模糊搜索" size="small" style="width:300px" ref="CnapsCode" @input="changeCCD"></el-input>
                <el-button type="primary" size="small" style="margin-left:10px" @click="querySearchAsync($event)">模糊搜索</el-button>
                <div v-show="showAddressSelect" class="addressSelect">
                  <div v-for="(item,index) in recommendList" :key="index" class="addressSelectItem cp" @click.stop="handleSelect(item)">
                    <span>{{ item.cnapsCode }}</span>
                    <span class="remake">{{item.fullName}}</span>
                  </div>
                  <div v-if="recommendList.length==0" class="empty">
                    暂无匹配项
                  </div>
                </div>
              </div>
              <div class="bankNameR" v-if="fullName && fullName != baseInfo.depositBank">
                联行号支行：{{fullName}}
              </div>
            </el-form-item>
            <el-form-item label="是否需要核销" prop="ProcessState">
              <el-radio-group v-model="payForm.ProcessState">
                <el-radio label="1">需要</el-radio>
                <el-radio label="0">不需要</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="" prop="ProcessState" label-width="0" v-if="payType==3 || payType==4">
              <el-checkbox v-model="needInternal">（可选）向打款账户内部转款：</el-checkbox>
              <el-select v-model="internalCompany" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeIC">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div class="infoTitle incInfo">OA流程信息
          <el-button type="text" size="small" @click="getMore">
            <i :class="!showMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
            {{ !showMore ? '展开' : '收起' }}</el-button>
        </div>


        <div v-if="showMore" class="showPaymentInfo">

          <table width="1000px" border="0" cellspacing="1" cellpadding="4" class="tabtop15" align="center">
            <tr>
              <td colspan="4" class="bttit font-center titfont">{{OAinfo.type}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">暂支编号</td>
              <td width="35%">{{OAinfo.oaNumber}}</td>
              <td width="15%" class="bttit font-center">申请时间</td>
              <td width="35%">{{OAinfo.applyTime.replace('0:00:00','')}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">申请公司</td>
              <td width="35%">{{OAinfo.applyCompanyName}}</td>
              <td width="15%" class="bttit font-center">申请部门</td>
              <td width="35%">{{OAinfo.applyDeptName}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">申请人</td>
              <td width="35%">{{OAinfo.applyUserName}}</td>
              <td width="15%" class="bttit font-center"></td>
              <td width="35%"></td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">服务公司</td>
              <td width="35%">{{OAinfo.serviceCompanyName}}</td>
              <td width="15%" class="bttit font-center">服务部门</td>
              <td width="35%">{{OAinfo.serviceDeptName}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">服务客户</td>
              <td width="35%">{{OAinfo.serviceCustomerName}}</td>
              <td width="15%" class="bttit font-center">服务中心/分子公司</td>
              <td width="35%">{{OAinfo.serviceCenterOrCompany}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">费用明细</td>
              <td width="35%">{{OAinfo.costName}}</td>
              <td width="15%" class="bttit font-center">费用金额</td>
              <td width="35%">{{OAinfo.costAmount}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">打款时间</td>
              <td width="35%">{{OAinfo.paymentTime}}</td>
              <td width="15%" class="bttit font-center">打款公司</td>
              <td width="35%">{{OAinfo.remitCompany}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">费用说明</td>
              <td colspan="3">{{OAinfo.costDesc }}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">开户银行</td>
              <td colspan="3">{{OAinfo.bankName}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">收款人账户名</td>
              <td colspan="3">{{OAinfo.paymentAccountName}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">银行账号</td>
              <td colspan="3">{{OAinfo.paymentAccount}}</td>
            </tr>
            <!-- <tr>
              <td width="15%" class="bttit font-center">相关附件</td>
              <td colspan="3">
                <span @click="toDownFile(OAinfo.fileUrl)" class="blueName cp">{{OAinfo.fileName && OAinfo.fileUrl ? OAinfo.fileName : ''}}</span>
              </td>
            </tr> -->
            <tr v-for="(item,index) in advOaFileList" :key="index">
              <td width="15%" class="bttit font-center">{{ index == -1 ?'相关附件' : '相关附件' + (index+1)}}</td>
              <td colspan="3">
                <span @click="toDownFile(item.oaDownloadurl)" class="blueName cp">{{item.fileName}}</span>
              </td>
            </tr>
            <tr v-if="advOaFileList.length==0">
              <td width="15%" class="bttit font-center">相关附件</td>
              <td colspan="3">
                <span @click="toDownFile(OAinfo.fileUrl)" class="blueName cp">{{OAinfo.fileName && OAinfo.fileUrl ? OAinfo.fileName : ''}}</span>
              </td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">核销情况</td>
              <td width="35%">{{OAinfo.name}}</td>
              <td width="15%" class="bttit font-center">核销金额</td>
              <td width="35%">{{OAinfo.name}}</td>
            </tr>
            <tr>
              <td width="15%" class="bttit font-center">核销说明</td>
              <td colspan="3">{{OAinfo.remark}}</td>
            </tr>
          </table>
        </div>

        <div class="botbox">
          <el-button type="primary" size="small" v-preventReClick @click="beforePay('payByCBS')" :disabled="isPaySuccess" v-if="payType==1 && baseInfo.payResult!=1 && baseInfo.payResult!=4">{{isPaySuccess ? '已操作' : '提交CBS打款'}}</el-button>

          <el-popconfirm title="请确认是否登记手工打款成功？" @confirm="handel('1')" style="margin-left: 10px;" :disabled="isPaySuccess" v-if="baseInfo.payResult!=1 && baseInfo.payResult!=4">
            <el-button type="success" slot="reference" size="small" :disabled="isPaySuccess" v-preventReClick>登记手工打款成功</el-button>
          </el-popconfirm>

          <el-popconfirm title="请确认是否登记手工打款失败？" @confirm="handel('2')" style="margin: 0 10px;" :disabled="isPaySuccess" v-if="baseInfo.payResult!=1 && baseInfo.payResult!=4">
            <el-button type="danger" slot="reference" size="small" :disabled="isPaySuccess" v-preventReClick>登记手工打款失败</el-button>
          </el-popconfirm>

          <el-button type="warning" size="small" v-preventReClick @click="beforePay('payByCoop')" :disabled="isPaySuccess" v-if="(payType==3 || payType==4) && coopList.length>0 && baseInfo.payResult!=1 && baseInfo.payResult!=4">合作账户打款</el-button>

          <el-button size="small" @click="cancel">返 回</el-button>
        </div>

      </div>
    </div>

    <el-dialog width="700px" title="选择打款账号" :visible.sync="innerVisibleCA">
      <div class="salaryPayingCompanyBox" v-if="BankAccount.length > 0">
        <div class="salaryPayingCompany">打款公司：{{ baseInfo.remitAgency }}</div>
        <div style="margin-bottom: 10px;">
          <el-radio-group v-model="payForm.RpaAccount" @input="changePayType">
            <el-radio :label="0">CBS银行账户</el-radio>
            <el-radio :label="1">杰小金账户</el-radio>
          </el-radio-group>
        </div>

        <!-- CBS银行账户 -->
        <div class="salaryPayingCompany_radio" v-if="payForm.RpaAccount==0">
          <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.payAccount">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
        </div>
        <!-- 杰小金账户 -->
        <div class="salaryPayingCompany_radio" v-if="payForm.RpaAccount==1">
          <el-radio :label="bank.Account" v-for="bank in JXJList" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.payAccount">开户行：{{ bank.OpeningBank }} 帐号：{{ bank.Account}}</el-radio>
        </div>
      </div>
      <div v-else class="noAccountTips">暂未配置打款公司CBS银行账户</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisibleCA = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmPay">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="提交内部转款" :visible.sync="innerVisibleIC">
      <div class="salaryPayingCompanyBox">
        <div class="salaryPayingCompany">付款方：
          <el-select v-model="internalCompany" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeIC">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div class="salaryPayingCompany_radio" v-if="icBankAccount.length > 0">
          <el-radio :label="bank.Account" v-for="bank in icBankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="InternalAccount">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
        </div>
      </div>
      <div v-if="icBankAccount.length == 0" class="noAccountTips">暂未配置{{internalCompany}}CBS银行账户</div>

      <div class="salaryPayingCompany flex sb">
        <div>收款方：{{ VisibleCoopSC ? severCompany : baseInfo.remitAgency }}</div>
        <div style="margin-right:50px">金额：￥{{ payForm.TotalFees }}</div>
      </div>
      <div>
        账户：{{ VisibleCoopSC ? coopInfo.payAccount : payForm.payAccount }}
      </div>
      <div style="margin-top:20px">
        <div class="salaryPayingCompany flex aic">打款金额：
          <div class="payInput">
            <el-input v-model="payForm.TotalFees" size="small" style="width:300px" type="number">
              <i slot="prepend">￥</i>
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!showSysTips && !showSysSms">
        <el-button @click="innerVisibleIC = false" size="small">取 消</el-button>
        <el-button type="warning" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" v-if="!VisibleCoop && !showBindTrueAccount" @click="pay">跳 过</el-button>
        <el-button type="primary" v-if="icBankAccount.length > 0 && !VisibleCoop && !showBindTrueAccount" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmICPay">确 定</el-button>
        <el-button type="primary" v-if="icBankAccount.length > 0 && (VisibleCoop || showBindTrueAccount)" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSCPay">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="请选择合作账户" :visible.sync="VisibleCoop">
      <div>
        <el-form>
          <el-form-item label="请选择合作账户">
            <el-select v-model="coop" placeholder="" size="small" style="width: 500px;" clearable filterable @change="changeCoop" value-key="acount">
              <el-option v-for="(item, index) in coopList" :key="index" :label="item.compName + '/' + item.acount + '/' + item.openingBank" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="VisibleCoop = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmCoop">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="选择真实账户" :visible.sync="showBindTrueAccount">
      <div>
        <el-form>
          <el-form-item label="选择真实账户">
            <el-select v-model="coop" placeholder="" size="small" style="width: 500px;" clearable filterable @change="changeCoop" value-key="acount">
              <el-option v-for="(item, index) in trueAccountData" :key="index" :label="item.acountName + '/' + item.acount + '/' + item.openingBank" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBindTrueAccount = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmCoop">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="从服务公司账户向合作账户转款" :visible.sync="VisibleCoopSC">
      <div class="salaryPayingCompanyBox">
        <div class="salaryPayingCompany">选择服务公司：
          <el-select v-model="severCompany" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeSC">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div class="salaryPayingCompany" v-if="severCompany">付款方：{{ baseInfo.remitAgency }}</div>
        <div class="salaryPayingCompany_radio" v-if="scBankAccount.length>0">
          <el-radio :label="bank.Account" v-for="bank in scBankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="coopInfo.payAccount">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
        </div>
        <div v-if="scBankAccount.length == 0 && severCompany" class="noAccountTips">暂未配置{{severCompany}}CBS银行账户</div>

        <div class="salaryPayingCompany flex sb">
          <div>收款方：{{ coopInfo.CooperatAccountName }}</div>
          <div style="margin-right:50px">金额：￥{{ payForm.TotalFees }}</div>
        </div>
        <div>
          开户行：{{ coopInfo.CooperatAccountDepositBank }} 账户：{{ coopInfo.CooperatAccount }}
        </div>
      </div>
      <div style="margin-top:20px">
        <div class="salaryPayingCompany flex aic">打款金额：
          <div class="payInput">
            <el-input v-model="payForm.TotalFees" size="small" style="width:300px" @input="payInput" type="number">
              <i slot="prepend">￥</i>
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="VisibleCoopSC = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmCoopSC">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="系统风控提醒" :visible.sync="showSysTips" width="815px" :show-close="false">
      <div class="payTips2">最近有向同一账号支付相同金额的记录，请确认是否重复支付!!！</div>
      <el-table :data="retList" class="doc_table" max-height="500px" style="width:100%;margin-bottom: 6px;" :loading="sysLoading">
        <el-table-column prop="updataTime" label="发生时间" min-width="160" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.updataTime  ? row.updataTime.replace('T',' ') : '' }}</template>
        </el-table-column>
        <!-- <el-table-column prop="employeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column> -->
        <el-table-column prop="num" label="编号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="bankAccount" label="卡号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="applyUserName" label="申请人" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="totalFees" label="金额" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{row.totalFees ? '￥' + row.totalFees : ''}}</template>
        </el-table-column>
        <el-table-column prop="modeStr" label="类型" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="processState" label="付款状态" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSysTips = false" size="small">暂时关闭</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="showSysSms = true">确认，继续</el-button>
      </span>
    </el-dialog>

    <el-dialog title="获取验证码" :visible.sync="showSysSms" width="500px" :show-close="false">
      <el-form>
        <el-form-item label="请输入验证码" label-width="100px">
          <el-input v-model="VerifCode" style="width:120px" size="small"></el-input>
          <el-button type="primary" size="small" style="margin-left:10px" :disabled="countdown>0" @click="sendSms">{{countdown == 0 ? '发送短信' : '重新发送（' + countdown + '）'}}</el-button>
        </el-form-item>
      </el-form>
      <div>注:验证码将发放到您在数字化系统登记的手机号</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSysSms = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="checkSms">确认发放</el-button>
      </span>
    </el-dialog>

    <el-dialog title="银行卡号异常提醒" :visible.sync="showErrTip" width="500px" :show-close="false">
      <div class="payTips2">检测到银行卡号异常，请核对银行卡号</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showErrTip = false" size="small">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          busiId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        rules: {},
        baseInfo: {},
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        loading: false,
        BankAccount: [], //银行列表
        isBtnLoading: false,
        innerVisibleCA: false,
        payForm: {
          id: '',
          TotalFees: '', //打款金额
          payAccount: '', //打款账号
          BusiType: '1', //1暂支 2 工作日志
          ProcessState: '1', //是否需要核销，为1是需要核销，为0是不用核销
          depositBank: '', //款项用途
          UseFunds: '', //款项用途
          CnapsCode: '', //联行号
          BankCode: '',
          InternalAccount: '', //内部账号
          InternalAccountName: '', //内部转账公司
          CooperatAccount: '', //合作账号
          CooperatAccountName: '', //合作账号名
          CooperatAccountDepositBank: '', //合作开户行
          RpaAccount: 0, // cbs / 杰小金
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        },
        coop: '',
        coopInfo: {
          payAccount: '',
          CooperatAccount: '', //合作账号
          CooperatAccountName: '', //合作账号名
          CooperatAccountDepositBank: '', //合作开户行
        },
        legList: [],
        advOaFileList: [], //附件列表
        isPaySuccess: false,
        showMore: false, //展开OA信息
        OAinfo: {},
        recommendList: [],
        trueAccountData: [], //真实账户列表
        showBindTrueAccount: false,
        payType: '', //0 正常模式 /3真实账户 /4虚拟账户
        coopList: [], //合作账户列表
        showAddressSelect: false,
        needInternal: false, //向打款账户内部转款
        internalCompany: '宁波英普瑞特供应链管理有限公司', //内部转账公司
        InternalAccount: '', //内部账户
        icBankAccount: [],
        innerVisibleIC: false,
        VisibleCoop: false, //合作账户打款
        VisibleCoopSC: false, //选择服务公司
        severCompany: '', //服务公司
        retList: [], //风控提醒列表
        showSysTips: false,
        showSysSms: false,
        countdown: 0,
        sysLoading: false,
        isLift: false, //是否解除风控
        VerifCode: '',
        scBankAccount: [],
        showErrTip: false, //银行卡异常提醒
        fullName: '',
        JXJList: [], //杰小金账户列表

        CS: {
          'text-align': 'center', //文本居中
          'min-width': '200px', //最小宽度
          'max-width': '200px',
          'word-break': 'break-all'
        },
        LS: {
          'background-color': 'fff',
          'text-align': 'center', //文本居中
          'min-width': '100px', //最小宽度
          'max-width': '100px',
        },
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.listQuery.busiId = this.$route.query.id;
        this.GetAdvancesDetail();
        this.GetAdvancesRiskAlert();
      }
      this.getlegalsubjectlist();
      this.changeIC('宁波英普瑞特供应链管理有限公司')
    },
    mounted() {
      const hander = (event) => {
        // console.log('监听中')
        this.foo(event)
      }
      document.addEventListener('click', hander)
      this.$once("hook:beforeDestroy", () => document.removeEventListener('click', hander));
    },
    methods: {
      checkPermission,
      //点击其他地方，关闭地图和地址选择下拉框
      foo(e) {
        if (this.$refs.chickBox1.contains(e.target)) {
          //点击的该区域的
          return
        } else {
          //点击别的区域关闭地址选择器
          this.showAddressSelect = false;
        }
      },
      GetAdvancesDetail() {
        this.loading = true;
        xz.GetAdvancesDetail(this.listQuery).then(res => {
          try {
            if (res.status == 'ok') {
              this.baseInfo = res.data.adVerifs;
              let regex = /[\u4e00-\u9fa5]/;
              let result = regex.test(this.baseInfo.receiptAccount)
              if (result) {
                this.showErrTip = true;
              }
              this.advOaFileList = res.data.advOaFileList;
              this.OAdata = res.data.list;
              this.loading = false;
              this.payForm.id = this.baseInfo.id;
              this.payForm.TotalFees = this.baseInfo.totalFees;
              this.payForm.depositBank = this.baseInfo.depositBank;
              this.payForm.UseFunds = this.baseInfo.projectName + this.baseInfo.costName;
              this.payForm.UseFunds = this.payForm.UseFunds.replace('返费', '');
              this.payForm.UseFunds = this.payForm.UseFunds.replace('过账', '');
              if (this.OAdata.length > 0 && this.OAdata[0].type != '工作日志') {
                this.OAinfo = this.OAdata[0]
              }
              this.GetCnapsCodeByrevAccount();
              this.GetCompanyNameAccount();
            } else {
              this.$message.error(res.msg);
              this.loading = false;
            }
          } catch {
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      getMore() {
        this.showMore = !this.showMore
      },
      //数字转中文大写
      numberToChinese(money) {
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      changeTab() {},
      //登记成功/失败
      handel(type) {
        if (!this.loading) {
          this.loading = true;
          let data = [{
            id: this.listQuery.busiId,
            payResult: type, //1代表成功,0为失败
            TotalFees: this.payForm.TotalFees, //打款金额
            ProcessState: this.payForm.ProcessState, //是否需要核销，为1是需要核销，为0是不用核销
            UseFunds: this.payForm.UseFunds, //款项用途
            depositBank: this.payForm.depositBank, //款项用途
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }]
          xz.remitAdvance(data).then(res => {
            try {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.loading = false;
                this.isPaySuccess = true;
              } else {
                this.loading = false;
                this.$message.error(res.msg);
              }
            } catch (e) {
              this.$message.error('系统出错');
              this.loading = false;
            }
          })
        }
      },
      beforePay(fun) {
        if (!this.isLift && this.retList.length > 0) {
          this.showSysTips = true;
        } else {
          this[fun]()
        }
      },
      //cbs打款
      payByCBS() {
        if (this.baseInfo.remitAgency) {
          this.payForm.payAccount = '';
          xz.getCompfinanceSet(this.baseInfo.remitAgency, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.BankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.payForm.payAccount = element.Account
                  }
                });
                this.BankAccount = res.data.BankAccountJ;
                this.innerVisibleCA = true;
              }
            } else {
              this.BankAccount = [];
            }
          })
        } else {
          this.$message.warning('未获取到打款公司')
        }
      },
      confirmPay() {
        if (this.payForm.TotalFees > this.baseInfo.totalFees) {
          this.$message.warning('打款金额不能大于申请金额')
        } else if (!this.payForm.payAccount) {
          this.$message.warning('请选择打款账号')
        } else {
          if (this.needInternal) {
            this.innerVisibleIC = true;
          } else {
            this.pay();
          }
        }
      },
      confirmICPay() {
        this.payForm.InternalAccount = this.InternalAccount;
        this.payForm.InternalAccountName = this.internalCompany;
        this.pay();
      },
      pay() {
        this.isBtnLoading = true;
        xz.cbsPayAdvance(this.payForm, this.roletype).then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('打款成功！');
              this.isBtnLoading = false;
              this.innerVisibleCA = false;
              this.VisibleCoop = false;
              this.innerVisibleIC = false;
              this.VisibleCoopSC = false;
              this.showBindTrueAccount = false;
              this.isPaySuccess = true;
            } else {
              this.isBtnLoading = false;
              this.innerVisibleCA = false;
              this.VisibleCoop = false;
              this.innerVisibleIC = false;
              this.showBindTrueAccount = false;
              this.VisibleCoopSC = false;
              this.$message.error(res.msg);
            }
          } catch (e) {
            this.$message.error('系统出错');
            this.isBtnLoading = false;
          }
        })
      },
      cancel() {
        // this.$router.go(-1);
        window.close();
      },
      //附件
      toDownFile(row) {
        const newWindow = window.open(url, "_blank");
      },
      payInput(val) {
        this.payForm.TotalFees = Number(val).toFixed(2)
      },
      GetCnapsCodeByrevAccount() {
        xz.GetCnapsCodeByrevAccount(this.baseInfo.receiptAccount).then(res => {
          if (res.status == 'ok') {
            let d = (res.data);
            if (d.cnapsCode != undefined) {
              this.payForm.CnapsCode = d.cnapsCode;
              this.payForm.BankCode = d.bankCode;
              this.payForm.depositBank = d.fullName;
            }
          } else {
            if (this.baseInfo.depositBank) {
              xz.GetCnapsCodeByName(this.baseInfo.depositBank, 10000, 1).then(res => {
                if (res.status == 'ok' && res.data.data.length > 0) {
                  this.payForm.CnapsCode = res.data.data[0].cnapsCode;
                  this.payForm.BankCode = res.data.data[0].bankCode;
                  this.fullName = res.data.data[0].fullName
                } else {
                  this.payForm.CnapsCode = ''
                }
              })
            }
          }
        })
      },
      handleSelect(item) {
        this.payForm.CnapsCode = item.cnapsCode;
        this.payForm.BankCode = item.bankCode;
        this.baseInfo.depositBank = item.fullName;
        this.showAddressSelect = false;
        this.fullName = item.fullName;
      },
      changeCCD() {
        this.fullName = ''
      },
      querySearchAsync(event) {
        if (this.payForm.CnapsCode != undefined && this.payForm.CnapsCode) {
          this.marY = event.clientY - 320 < 0 ? 0 : event.clientY - 320;
          this.marX = event.clientX - 300 < 0 ? 0 : event.clientX - 300;
          xz.GetCnapsCodeByName(this.payForm.CnapsCode, 10000, 1).then(res => {
            if (res.status == 'ok') {
              this.recommendList = res.data.data;
              this.showAddressSelect = true;
            } else {
              this.recommendList = [];
              this.showAddressSelect = true;
            }
          })
        }
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //获取合作账户
      GetCompanyNameAccount() {
        xz.GetCompanyNameAccount(this.baseInfo.remitAgency).then(res => {
          if (res.status == 'ok') {
            this.payType = res.data.type;
            if (res.data.data != undefined && res.data.data.length > 0) {
              this.coopList = res.data.data;
              this.severCompany = res.data.data[0].compName;
              this.changeSC(this.severCompany)
            }
          } else {
            this.coopList = [];
          }
        })
      },
      changeIC(val) {
        console.log(val)
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.icBankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.InternalAccount = element.Account
                  }
                });
                this.icBankAccount = res.data.BankAccountJ;
              }
            } else {
              this.icBankAccount = [];
            }
          })
        }
      },
      payByCoop() {
        if (this.payType == 3) {
          this.VisibleCoop = true;
        } else {
          this.GetAdvCooperationaAcountList();
          this.showBindTrueAccount = true;
        }
      },
      //获取所有真实账户
      GetAdvCooperationaAcountList() {
        let data = {
          pageModel: {
            rows: 100,
            page: 1,
            orderInput: [{
              property: "updataTime",
              order: 0
            }]
          },
          id: "",
          compName: "",
          acountName: "",
          acount: "",
          openingBank: "",
          isCbsAcount: "",
          compType: 3,
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        }
        xz.AdvanceFun(data, 'GetAdvCooperationaAcountList').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.trueAccountData = res.data.data;
          } else {
            this.loading = false;
            this.trueAccountData = [];
          }
        })
      },
      changeCoop(val) {
        console.log(val)
        this.coopInfo.CooperatAccount = val.acount;
        this.coopInfo.CooperatAccountName = val.acountName;
        this.coopInfo.CooperatAccountDepositBank = val.openingBank;
      },
      confirmCoop() {
        if (this.coopInfo.CooperatAccount) {
          // this.VisibleCoopSC = true;
          if (this.needInternal) {
            this.innerVisibleIC = true;
          } else {
            this.VisibleCoopSC = true;
          }
        } else {
          this.$message.warning('请选择合作账户')
        }
      },
      changeSC(val) {
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.scBankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.coopInfo.payAccount = element.Account
                  }
                });
                this.scBankAccount = res.data.BankAccountJ;
              }
            } else {
              this.scBankAccount = [];
            }
          })
        }
      },
      confirmCoopSC() {
        if (this.coopInfo.payAccount) {
          // if (this.needInternal) {
          //   this.innerVisibleIC = true;
          // } else {
          this.payForm.payAccount = this.coopInfo.payAccount;
          this.payForm.CooperatAccount = this.coopInfo.CooperatAccount;
          this.payForm.CooperatAccountName = this.coopInfo.CooperatAccountName;
          this.payForm.CooperatAccountDepositBank = this.coopInfo.CooperatAccountDepositBank;
          this.pay();
          // }
        } else {
          this.$message.warning("请选择服务公司账户")
        }
      },
      confirmSCPay() {
        this.VisibleCoopSC = true;
        // this.payForm.payAccount = this.coopInfo.payAccount;
        // this.payForm.CooperatAccount = this.coopInfo.CooperatAccount;
        // this.payForm.CooperatAccountName = this.coopInfo.CooperatAccountName;
        // this.payForm.CooperatAccountDepositBank = this.coopInfo.CooperatAccountDepositBank;
        // this.pay();
      },
      GetAdvancesRiskAlert() {
        this.loading = true;
        xz.GetAdvancesRiskAlert(this.listQuery.busiId).then(res => {
          try {
            if (res.data.retList.length > 0) {
              this.retList = res.data.retList;
              this.loading = false;
            } else {
              this.loading = false;
            }
          } catch (e) {
            console.log(e)
            this.loading = false;
          }
        })
      },
      sendSms() {
        xz.SendPayRiskVerifCodeAdvances(this.listQuery.busiId, Cookies.get("userid-b")).then(res => {
          if (res.status == 'ok') {
            this.$message.success('验证码发送成功')
            this.timecount()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      timecount() {
        const TIME_COUNT = 60; //倒计时60秒
        if (!this.timer) {
          this.countdown = TIME_COUNT;
          this.isDisabled = true;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      checkSms() {
        if (this.VerifCode) {
          xz.CheckPayRiskVerifCodeAdvances(this.listQuery.busiId, Cookies.get("userid-b"), this.VerifCode).then(res => {
            if (res.status == 'ok') {
              this.$message.success('该笔打款已解除系统风控');
              this.isLift = true;
              this.showSysTips = false;
              this.showSysSms = false;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      },
      changePayType(val) {

        if (val == 1) {
          let str = `?AccountName=${this.baseInfo.remitAgency}`;
          xz.ArdCurStatGetFun('GeProductName', str).then(res => {
            if (res.status == 'ok') {
              this.JXJList = this.capitalizeKeys(res.data);
            } else {
              this.JXJList = [];
            }
          })
        }
      },
      //首字母转大写
      capitalizeKeys(obj) {
        if (typeof obj !== 'object' || obj === null) return obj;
        if (Array.isArray(obj)) {
          return obj.map(item => this.capitalizeKeys(item));
        }
        const capitalizedObj = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            // 将属性名首字母转大写
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            capitalizedObj[capitalizedKey] = obj[key];
          }
        }
        return capitalizedObj;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .showPaymentInfo {
    // width: 1161px;
  }

  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .showMore {
    width: 1088px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    border: 1px solid #ebebeb;
    border-top: 1px solid #eaeefb;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .descriptions_box {
    margin-bottom: 20px;
  }

  .descriptionsTitle {
    border: 1px solid #B7BABD;
    border-bottom: none;
    // margin: 0 auto;
    padding: 8px 0;
    font-size: 13px;
    font-weight: 600;
    color: #000;
    text-align: center;
  }

  .botbox {
    margin-top: 30px;
    padding-bottom: 20px;
  }

  .salaryPayingCompanyItem {
    margin-bottom: 30px;
  }

  .salaryPayingCompany {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .salaryPayingCompany_radio {
    padding-left: 30px;
  }

  .tabtop13 {
    margin-top: 5px;
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .tabtop15 td {
    padding: 8px;
    word-break: break-word;
    font-size: 14px;
  }

  .font-center {
    text-align: center
  }

  .biaoti {
    font-family: 微软雅黑;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px dashed #CCCCCC;
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
    // background: url(../images/ico3.gif) no-repeat 15px center;
  }

  .bttit {
    background: #F6F6F6 !important;
  }

  .tabtxt2 {
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
  }

  .tabtxt3 {
    font-family: 微软雅黑;
    font-size: 14px;
    padding-left: 15px;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
  }

  .showPaymentInfo table td,
  .showPaymentInfo table th {
    border: 1px #d2d2d2 solid;
  }

  .addressSelect {
    width: 450px !important;
    position: absolute;
    top: 40px;
    background: #fff;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 200px;
    width: 300px;
    overflow: auto;
    padding: 10px 0;
    z-index: 2000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  .addressSelectItem {
    padding: 0 0 0 10px;
  }

  .remake {
    color: #AAAAAA;
    margin-left: 10px;
    font-size: 12px;
  }

  .noAccountTips {
    font-size: 14px;
    margin-bottom: 15px;
  }

  .chickBox1 {
    width: 800px;
  }

  .bankNameR {
    color: red;
    font-size: 12px;
  }

  .payTips2 {
    color: red;
    font-size: 16px;
  }
</style>
<style>
  .page_tePayment .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePayment .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tePayment .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePayment .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePayment .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 1px solid #B7BABD;
  }

  .payInput .el-input-group__append,
  .payInput .el-input-group__prepend {
    padding: 0 0 0 5px;
    background: #fff;
    border-right: none !important;
  }

  .payInput .el-input__inner {
    border-left-color: #fff;
    padding-left: 3px;
  }

  .page_tePayment .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>